import React, { useState, useRef, useEffect } from 'react';
import { Input } from '@progress/kendo-react-inputs';
const OtpInput = ({ length = 6, onComplete, onChange, value }) => {
    const [otp, setOtp] = useState(new Array(length).fill(''));
    const inputRefs = useRef([]);

    useEffect(() => {
        if (value) {
            const valueArray = value.toString().split('').slice(0, length);
            const newOtp = new Array(length).fill('');
            
            valueArray.forEach((digit, index) => {
                if (index < length && !isNaN(digit)) {
                    newOtp[index] = digit;
                }
            });
            
            setOtp(newOtp);
            
            if (newOtp.every(digit => digit !== '')) {
                onComplete && onComplete(newOtp.join(''));
            }
            onChange && onChange(newOtp.join(''));
        }
    }, [value]);

    const handleChange = (e, index) => {
        const value = e.target.value;
        if (isNaN(value) || value.length > 1) return;

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);
        onChange && onChange(newOtp.join(''));

        if (value && index < length - 1) {
            inputRefs.current[index + 1].focus();
        } else if (newOtp.every(digit => digit !== '')) {
            onComplete && onComplete(newOtp.join(''));
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace' && !otp[index] && index > 0) {
            inputRefs.current[index - 1].focus();
        }
    };

    return (
        <div style={{ display: 'flex', gap: '8px' }}>
            {otp.map((digit, index) => (
                <Input
                    key={index}
                    type="text"
                    value={digit}
                    onChange={(e) => handleChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    maxLength={1}
                    style={{ width: '40px', textAlign: 'center' }}
                    ref={(el) => (inputRefs.current[index] = el)}
                />
            ))}
        </div>
    );
};

export default OtpInput;